export default class Search {
    private static searchContainer: HTMLElement | null = null;
    private static searchInput: HTMLInputElement | null = null;
    private static searchResults: HTMLElement | null = null;
    private static searchForm: HTMLFormElement | null = null;
    private static searchTimeout: number | null = null;

    static init(): void {
        this.searchContainer = document.querySelector('.js-search-container');
        this.searchInput = document.querySelector('.js-search-input');
        this.searchResults = document.querySelector('.js-search-results');
        this.searchForm = this.searchContainer?.querySelector('form') || null;

        if (!this.searchContainer || !this.searchInput || !this.searchResults || !this.searchForm) {
            return;
        }

        this.bindEvents();
    }

    private static bindEvents(): void {
        if (!this.searchInput || !this.searchResults || !this.searchForm) return;

        // Handle input with debouncing
        this.searchInput.addEventListener('input', (event) => {
            const target = event.target as HTMLInputElement;
            const query = target.value.trim();

            // Clear previous timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            if (query.length === 0) {
                this.hideResults();
                return;
            }

            if (query.length < 3) {
                this.showMessage('Zadejte alespoň 3 znaky');
                return;
            }

            // Debounce search for 300ms
            this.searchTimeout = window.setTimeout(() => {
                this.performSearch();
            }, 300);
        });

        // Handle focus - show results if they exist
        this.searchInput.addEventListener('focus', () => {
            if (this.searchResults && this.searchResults.innerHTML.trim() !== '') {
                this.showResults();
            }
        });

        // Handle click outside to hide results
        document.addEventListener('click', (event) => {
            if (!this.searchContainer?.contains(event.target as Node)) {
                this.hideResults();
            }
        });

        // Handle escape key and enter key
        this.searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.hideResults();
                this.searchInput?.blur();
            } else if (event.key === 'Enter') {
                // On Enter, submit form normally (not AJAX) to redirect to SearchPresenter
                event.preventDefault();
                if (this.searchForm) {
                    // Remove AJAX class temporarily to force normal submission
                    this.searchForm.classList.remove('ajax');
                    this.searchForm.submit();
                }
            }
        });

        // Handle form submission
        this.searchForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.performSearch();
        });

        // Listen for Naja events to show/hide results
        _naja.addEventListener('success', (event) => {
            if (event.detail.options.form === this.searchForm) {
                this.showResults();
            }
        });

        _naja.addEventListener('error', (event) => {
            if (event.detail.options.form === this.searchForm) {
                this.showMessage('Chyba při vyhledávání');
            }
        });
    }

    private static performSearch(): void {
        if (!this.searchForm) return;

        // Submit the form via Naja
        _naja.uiHandler.submitForm(this.searchForm);
    }

    private static showResults(): void {
        if (!this.searchResults) return;
        
        this.searchResults.style.display = 'block';
        this.searchContainer?.classList.add('is-active');
    }

    private static hideResults(): void {
        if (!this.searchResults) return;
        
        this.searchResults.style.display = 'none';
        this.searchContainer?.classList.remove('is-active');
    }

    private static showMessage(message: string): void {
        if (!this.searchResults) return;

        this.searchResults.innerHTML = `
            <div class="nav-search-content__inner">
                <div class="nav-search-content__item">
                    <div class="base-text base-text--small nav-search-content__empty">
                        ${message}
                    </div>
                </div>
            </div>
        `;
        this.showResults();
    }
}